module.exports = "/img/story-2.ed15a850.png";